<template>
    <div class="mian">
        <!-- 侧边栏 -->
        <div class="leftbox">
            <!-- 内容区域 -->
            <!-- <img class="imgbox" src="@/assets/Mask group@2x.png" /> -->
            <!-- 列表区域 -->
            <div class="listbox">
                <div class="iconbox" @click="gohome">
                    <img class="iconbox" src="@/assets/fenlikeimg/logo@2x.png" alt="">
                </div>

                <div class="menubox">
                    <el-menu :default-active="menu" unique-opened=true active-text-color="rgba(22, 111, 216, 1)"
                        text-color="rgba(10, 28, 70, 1)" @select="selectfun" ref="menuRef" class="custom-menu"
                        :default-openeds='menuopen' @open="openSubmenu" @close="closeSubmenu">
                        <el-sub-menu index="/Homepage">
                            <template #title>
                                <el-icon>
                                    <MenuIcon :current-path="menuopen[0]" target-path="/Homepage"
                                        active-icon="yibiao1@2x.png" inactive-icon="yibiao@2x.png" />
                                </el-icon>
                                <span>仪表盘</span>
                            </template>
                            <el-menu-item index="/onhome">数据统计 </el-menu-item>

                        </el-sub-menu>
                        <el-sub-menu index="/Listpage">
                            <template #title>
                                <el-icon>
                                    <MenuIcon :current-path="menuopen[0]" target-path="/Listpage"
                                        active-icon="tuiguang1@2x.png" inactive-icon="tuiguang@2x.png" />
                                </el-icon>
                                <span>我要推广</span>
                            </template>
                            <el-menu-item index="/Listproducts">推广活动</el-menu-item>
                            <el-menu-item index="/Promotionadd">推广学院</el-menu-item>
                        </el-sub-menu>
                        <el-sub-menu index="/Promotion">
                            <template #title>
                                <el-icon>
                                    <MenuIcon :current-path="menuopen[0]" target-path="/Promotion"
                                        active-icon="guanli1@2x.png" inactive-icon="guanli@2x.png" />
                                </el-icon>
                                <span>推广管理</span>
                            </template>

                            <el-menu-item index="/Promotion_management">媒体列表</el-menu-item>
                            <el-menu-item index="/Promotional_list">推广位列表</el-menu-item>

                        </el-sub-menu>
                        <el-sub-menu index="/Order">
                            <template #title>
                                <el-icon>
                                    <MenuIcon :current-path="menuopen[0]" target-path="/Order"
                                        active-icon="shuju1@2x.png" inactive-icon="shuju@2x.png" />
                                </el-icon>
                                <span>推广数据</span>
                            </template>
                            <el-menu-item index="/Orderlist">
                                订单数据
                            </el-menu-item>
                            <el-menu-item index="/Orderlistviewer">
                                结算数据
                            </el-menu-item>

                        </el-sub-menu>
                        <el-sub-menu index="/Personalcenter">
                            <template #title>
                                <el-icon>
                                    <MenuIcon :current-path="menuopen[0]" target-path="/Personalcenter"
                                        active-icon="wode1@2x.png" inactive-icon="wode@2x.png" />
                                </el-icon>
                                <span>个人中心</span>
                            </template>

                            <el-menu-item index="/PersonalInformation">个人信息</el-menu-item>
                            <el-menu-item index="/mesge">消息中心</el-menu-item>
                        </el-sub-menu>
                    </el-menu>
                </div>
            </div>
        </div>
        <div class="rightbox">
            <header>
                <div class="Page_Routing">
                </div>
                <div class="plaintext">
                    <!-- 客服 -->
                    <el-popover ref="popover" :width="'auto'"
                        popper-style="text-align: center; min-width: 60px; padding: 8px 12px;" trigger="hover"
                        content="客服" placement="bottom">
                        <template #reference>
                            <img class="iconbox" src="@/assets/fenlikeimg/headerico/kefu@2x.png" alt=""
                                @click="navigate_kefu">
                        </template>
                    </el-popover>
                    <!-- <img class="iconbox" src="@/assets/fenlikeimg/headerico/kefu@2x.png" alt="" @click="navigate_kefu"> -->
                    <!-- 消息 -->
                    <el-popover ref="popover" :width="'auto'" popper-style="text-align: center; min-width: 60px;"
                        trigger="hover" content="消息中心" placement="bottom">
                        <template #reference>
                            <div class="iconbox " :class="{ 'icondd': getUnreadMsgList }">
                                <img src="@/assets/fenlikeimg/headerico/xiaoxi@2x.png" alt="" @click="navigate_one">
                            </div>
                        </template>
                    </el-popover>
                    <el-popover ref="popover" :width="'auto'" popper-style="text-align: center; min-width: 60px;"
                        trigger="hover" :content="userInfo?.nick" placement="bottom">
                        <template #reference>
                            <div class="conentbox" @click="navigate_chage('/PersonalInformation')">

                                <!-- v-if="!userInfoStore.getUserAvatar -->
                                <!-- 默认用户头像 -->
                                <img class="iconbox" src="@/assets/fenlikeimg/headerico/touxiang@2x.png" alt=""
                                    v-if="!userInfo?.avatar">
                                <img class="iconbox" :src="userInfo?.avatar" alt="" v-else>
                                <!--  -->
                                <div class="unloginbtn">{{ userInfo?.nick }}</div>
                            </div>
                        </template>
                    </el-popover>


                </div>
            </header>
            <!-- 路由出口 -->
            <div class="main">
                <router-view />
            </div>
        </div>
        <!-- 客服弹窗 -->
        <el-dialog v-model="kefu_popup" class="kefu_popup" :show-close="false">
            <div class="kefu_popup_content">
                <div class="kefu_popup_content_title">
                    <img src="@/assets/fenlikeimg/headerico/kefu@2x.png" alt="" srcset="">
                    <span>客服</span>
                </div>
                <div class="kefu_popup_content_list">
                    <!-- 1 复制 2 扫码   3 跳转微信 -->
                    <div class="kefu_popup_content_item" v-for="(item, index) in getConfiglist" :key="item">
                        <div class="kefu_popup_content_item_title">
                            <span>{{ item.name }}</span>
                        </div>
                        <div class="kefu_popup_content_item_remark" v-show="item.remark">
                            <span>备注:{{ item.remark }}</span>
                        </div>
                        <div class="kefu_popup_content_item_content">
                            <div class="kefu_popup_content_item_content_item" v-show="item.type === 1">
                                <div class="textbox">{{ item.value }}</div>
                                <img src="../../assets/tuiguangicon/copy@2x.png" alt="" srcset=""
                                    @click="copyToClipboard(item.value)">
                            </div>
                            <img class="kefu_popup_content_item_content_qr" :src="item.value" v-show="item.type === 2">

                            </img>

                            <div class="kefu_popup_content_item_content_btn" v-show="item.type === 3"
                                @click="gotokefu(item.value)">
                                <img :src="item.icon" alt="" srcset="">
                                <span>联系客服</span>

                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </el-dialog>

        <!-- 公告弹窗 -->
        <el-dialog v-model="item.showblen" class="gonggao_popup" :show-close="false"
            v-for="(item, index) in gonggao_popup" :key="item" @close="closeGonggao(item, index)">
            <div class="gonggao_popup_content">
                <img :src="item.img" class="gonggao_popup_content_content" @click="clickGonggao(item, index)">

                </img>
                <img class="guanbiicon" src="../../assets/cha@2x.png" alt="" @click="closeGonggao(item, index)">
            </div>
        </el-dialog>


    </div>
</template>

<script setup lang="ts">
import { ref, watchEffect, watch, onMounted, nextTick, computed } from 'vue';
import { useRouter, useRoute } from "vue-router";
import MenuIcon from '@/components/MenuIcon';
import { user_info, common_announcement_list, getUnreadMsg } from '@/services/request';
import { useTypeConfigStore, useUserInfoStore, useConfigListStore, useMediaTypeStore, useRouteParamsStore } from '@/stroe/pinia'
import { ElMessage } from 'element-plus';
import { timestampToDateTime } from '@/utils/utils';
//事件转换

// 客服弹窗
const kefu_popup = ref(false)
// 公告弹窗 数组
const gonggao_popup = ref([])

// 使用store 获取类型配置集合
const typeConfigStore = useTypeConfigStore()
// 使用store 获取配置列表
const configListStore = useConfigListStore()
// 使用store 获取媒体类型集合
const mediaTypeStore = useMediaTypeStore()
// 使用store 管理路由参数
const routeParamsStore = useRouteParamsStore()

const getConfiglist = ref([])



/**
 * 公告弹窗显示控制函数
 * @param maxNum 每日展示最大次数（0表示无限制）
 * @param duration 两次展示的间隔时长（秒，0表示无限制）
 * @returns boolean 是否应该显示公告
 */
const gonggao_popup_control = (maxNum: number = 0, duration: number = 0): boolean => {
    const today = new Date().toLocaleDateString()
    const currentTimestamp = Date.now()
    const storageKey = 'gonggao_popup_control'

    try {
        // 获取本地存储的控制数据
        const localStorageData = getLocalControlData(storageKey)

        // 如果是新的一天，重置计数
        if (!localStorageData || localStorageData.today !== today) {
            const newControlData = {
                today,
                displayCount: 0,
                lastDisplayTime: 0
            }
            saveLocalControlData(storageKey, newControlData)
            return shouldDisplayAnnouncement(newControlData, maxNum, duration, currentTimestamp)
        }

        // 同一天的逻辑处理
        return shouldDisplayAnnouncement(localStorageData, maxNum, duration, currentTimestamp)

    } catch (error) {
        console.error('公告控制逻辑处理失败:', error)
        return false
    }
}

/**
 * 获取本地存储的控制数据
 */
const getLocalControlData = (storageKey: string) => {
    try {
        const stored = localStorage.getItem(storageKey)
        return stored ? JSON.parse(stored) : null
    } catch (error) {
        console.error('读取本地存储失败:', error)
        return null
    }
}

/**
 * 保存控制数据到本地存储
 */
const saveLocalControlData = (storageKey: string, data: any) => {
    try {
        localStorage.setItem(storageKey, JSON.stringify(data))
    } catch (error) {
        console.error('保存本地存储失败:', error)
    }
}
/**
 *  是否有未读
 */
// const unreadMsg = ref(false)
/**
 *  获取 未读消息 如果
 */
const getUnreadMsgList = computed(() => {
    console.log(userInfoStore.userInfo, '未读消息');
    for (const key in userInfoStore.userInfo?.msgNum) {
        if (userInfoStore.userInfo?.msgNum[key] > 0) {

            return true
        }
    }
    return false
})


/**
 * 判断是否应该显示公告
 */
const shouldDisplayAnnouncement = (
    controlData: any,
    maxNum: number,
    duration: number,
    currentTimestamp: number
): boolean => {
    // 检查每日展示次数限制
    if (maxNum > 0 && controlData.displayCount >= maxNum) {
        console.log(`今日公告展示次数已达上限: ${maxNum}`)
        return false
    }

    // 检查展示间隔时长限制
    if (duration > 0 && controlData.lastDisplayTime > 0) {
        const timeDiff = (currentTimestamp - controlData.lastDisplayTime) / 1000
        if (timeDiff < duration) {
            console.log(`公告展示间隔未达到要求: ${timeDiff}s < ${duration}s`)
            return false
        }
    }

    // 更新显示记录
    controlData.displayCount++
    controlData.lastDisplayTime = currentTimestamp
    saveLocalControlData('gonggao_popup_control', controlData)

    console.log(`公告可以展示，当前展示次数: ${controlData.displayCount}`)
    return true
}

/**
 *  获取公告信息
 */
const getGonggaoList = async () => {
    try {
        const res = await common_announcement_list({})
        if (res.code === 0) {
            console.log(res.data, '公告信息');

            // 处理公告数据，根据控制逻辑决定是否显示
            if (Array.isArray(res.data) && res.data.length > 0) {
                // 获取第一个公告的配置参数（假设所有公告使用相同的控制参数）
                const firstAnnouncement = res.data[0]
                const maxNum = firstAnnouncement?.maxNum || 0
                const duration = firstAnnouncement?.duration || 0

                // 统一检查是否应该显示公告（只检查一次）
                const shouldDisplay = gonggao_popup_control(maxNum, duration)

                if (shouldDisplay) {
                    // 设置显示状态：第一个公告立即显示，其他等待
                    gonggao_popup.value = res.data.map((item: any, index: number) => {
                        return {
                            ...item,
                            showblen: index === 0 ? true : false
                        }
                    })
                    console.log(`公告可以显示，共${res.data.length}条公告`)
                } else {
                    gonggao_popup.value = []
                    console.log('公告不满足显示条件，跳过显示')
                }
            }
        }
    } catch (error) {
        console.error('获取公告信息失败:', error)
    }
}




// 关闭公告弹窗 逻辑 当 第一个弹窗关闭时，第二个弹窗打开 一次循环下去知道所有弹窗关闭
const closeGonggao = (item: any, index: number) => {
    console.log(item, index, '关闭公告弹窗', gonggao_popup.value[index]);
    let num = gonggao_popup.value.length - 1
    gonggao_popup.value[index].showblen = false
    // item.showblen = false
    if (index < num) {
        gonggao_popup.value[index + 1].showblen = true
    }

}

const clickGonggao = (item: any, index: number) => {
    console.log(item, index, '点击公告弹窗');
    // item.showblen = false
    //oType
    // integer  | 
    // null 
    // 可选
    // 操作类型（1：仅查看内容，2：打开链接，3：打开富文本内容），默认仅查看内容
    // router.push({ path: '/rixchtext', query: { data: item.oType } })
    let num = gonggao_popup.value.length - 1
    gonggao_popup.value[index].showblen = false


    if (item.oType === 1) {

    } else if (item.oType === 2) {
        window.open(item.value, '_blank')
    } else if (item.oType === 3) {
        item.showblen = false
        //跳转到富文本内容
        // 使用 Pinia 传递参数
        routeParamsStore.setParams('/rixchtext', { data: item.id })
        router.push({ path: '/rixchtext' })



    }



}









onMounted(async () => {
    // 初始化store（从localStorage加载缓存数据）
    // typeConfigStore.initStore()
    // userInfoStore.initStore()
    // configListStore.initStore()
    getGonggaoList()
    // 如果没有有效数据，则请求接口

    try {
        await typeConfigStore.fetchTypeConfig()
    } catch (error) {
        console.error('初始化加载数据失败:首页----------------------------------', error)
    }


    // 获取配置列表（登录成功后）

    try {
        await configListStore.fetchConfigList()
        const getConfigByIdlist = computed(() => configListStore.getConfigById(7))
        getConfiglist.value = JSON.parse(getConfigByIdlist.value.value)
        console.log(getConfiglist.value, '客服信息列表');
        console.log('配置列表加载成功')
    } catch (error) {

        console.error('获取配置列表失败:', error)
    }

    // 获取媒体类型集合

    try {
        await mediaTypeStore.fetchMediaType()
    } catch (error) {
        console.error('获取媒体类型集合失败:', error)
    }


    getUserInfo()
})

// 用户信息现在通过userInfoStore管理








/**
 * 控制 管理员下拉列表模块的显示隐藏
 */
const Dropdownbox = ref(false)
const router = useRouter()
const route = useRoute()
const userInfoStore = useUserInfoStore()
/**
 * 用户信息
 */
const userInfo = computed(() => userInfoStore.userInfo?.userInfo)

const copyToClipboard = (value: string) => {
    navigator.clipboard.writeText(value)
    ElMessage.success('复制成功')
}




const navigate_chage = (url: string) => {
    router.push({ path: url })
}
const navigate_verify = () => {
    router.push({ path: '/verify' })
}
/**
 *  打开客服弹窗
 */
const navigate_kefu = () => {
    kefu_popup.value = true
}




//**
//  * 跳转消息列表
//  */
const navigate_one = () => {
    router.push({ path: '/mesge' })
}

const gotokefu = (value: string) => {
    window.open(value, '_blank')
}



/**
 * 侧边栏实例
 */
const menuRef = ref<any>()
/**
/** 
 * 展开回调
*/
const selectfun = (e: any) => {
    console.log(e, '展开回调');
    if (e.includes('/')) {
        router.push({ path: e })
    }
}
/**
 * 默认选中
 */
const menu: any = ref('/onhome')
/**
 * 默认展开板块
 */
const menuopen = ref(['/onhome'])
/**
 * 展开回调
 */
const handleOpen = (key: string) => {
    console.log(key, '展开回调');
    // if (key.includes('/')) {
    //     router.push({ path: key })
    // }
}
/**
 * 展开反选
 */
onMounted(() => {
    console.log(menuRef.value);

})
const openSubmenu = (e: any) => {
    console.log(e, '展开回调');
    menuopen.value = [`${e}`]
};
const closeSubmenu = (e: any) => {
    console.log(e, '关闭回调');
    menuopen.value = []
};
// 
/**
 * 跳转到首页
 */
const gohome = () => {
    router.push({ path: '/onhome' })
}
watch(route, (newdata, olddata) => {
    console.log('路由发生变化', newdata, olddata);
    menu.value = `${newdata.matched[1].path}`
    menuopen.value = [`${newdata.matched[0].path}`]

}, { immediate: true })



/**
 *  获取个人信息  有两种 个人信息userInfo和 个人认证信息authInfo
 *  "data": {
        "authInfo": {
            "applyTime": "2025-08-27 16:02:56",
            "cBLNo": "",
            "id": 1,
            "idName": "王*",
            "idNo": "420***********7893",
            "idValidPeriod": "2022.04.08-2042.04.08",
            "passTime": "2025-08-27 17:41:29",
            "status": 2,
            "type": 1,
            "uid": 1
        },
        "userInfo": {
            "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/eEcTM0s2IwWGtGzh36sJqyhyuvoibnrvrc6RibPlOzwG9vxzADKJ9NosOGsMAgpRa5pO5KEYHXmPP4tdC2evwwJw/132",
            "id": 1,
            "mediaNum": 1,
            "mobile": "136****8127",
            "nick": "Tank",
            "positionNum": 6,
            "registerTime": "2025-08-27 15:20:36",
            "role": 2,
            "roleChangeTime": "2025-08-27 17:41:28",
            "status": 1
        }
    },
 */
const getUserInfo = async () => {
    try {
        await userInfoStore.fetchUserInfo()
        console.log(userInfoStore.userInfo, 'userInfo-------------------');
    } catch (error) {
        console.log(error, '获取个人信息');
        ElMessage.error('获取用户信息失败')
    }
}










</script>

<style lang="less" scoped>
.listboxuser {
    // position: absolute;
    width: 160px;
    height: auto;
    background: rgba(255, 255, 255, 1);
    // background: wheat;
    border-radius: 10px 10px 10px 10px;
    // border: 1px solid;
    border-image: linear-gradient(136deg, rgba(255, 255, 255, 1), rgba(243, 243, 243, 1)) 1 1;
    bottom: -160px;
    transition-duration: 0.2s;
    overflow: hidden;

    .item {
        font-weight: 400;
        font-size: 14px;
        color: #FF8C00;
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }

    .item:hover {
        background: #FF8C00;
        color: white;
    }
}

.kefu_popup {
    width: 518px !important;
    height: 702px;
    background: #F0F5FF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);



   
}

:deep(.kefu_popup) {

    width: 518px !important;
    height: 702px !important;
    background: #F0F5FF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
    border-radius:15px;

    box-sizing: border-box;
    padding: 0px !important;

    .el-dialog__header {
        // display: none;
        background: none !important;
        border-bottom: none !important;
        padding: 0px !important;

    }

    .el-dialog__body {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 30px 30px 30px 30px !important;

        .kefu_popup_content {
            width: 100%;
            height: 100%;

            display: flex;
            flex-direction: column;

            .kefu_popup_content_title {
                width: 100%;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #0A1C46;
                gap: 10px;
                margin-bottom: 16px;

                img {
                    width: 30px;
                    height: 30px;
                }

            }

            .kefu_popup_content_list {
                width: 100%;
                flex: 1;
                // background: wheat;
                display: flex;
                flex-direction: column;
                gap: 20px;

                .kefu_popup_content_item {
                    width: 100%;
                    height: auto;
                    display: flex;
                    flex-direction: column;
                    // gap: 4px;
                    // background: wheat;

                    .kefu_popup_content_item_title {
                        font-family: PingFang HK, PingFang HK;
                        font-weight: 600;
                        font-size: 18px;
                        color: #0A1C46;
                        margin-bottom: 2px;
                    }

                    .kefu_popup_content_item_remark {
                        width: 100%;
                        height: 20px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #888888;
                        margin-bottom: 10px;

                    }

                    .kefu_popup_content_item_content {
                        width: 100%;
                        min-height: 48px;



                        .kefu_popup_content_item_content_item {
                            width: 100%;
                            height: 48px;
                            background: #FFFFFF;
                            border-radius: 15px;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding: 10px 20px;

                            .textbox {
                                flex: 1;
                                height: 100%;
                                // background: wheat;
                                display: flex;
                                align-items: center;
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 400;
                                font-size: 20px;
                                color: #678ADC;
                            }

                            img {
                                width: 20px;
                                height: 20px;
                            }


                        }

                        .kefu_popup_content_item_content_qr {
                            width: 160px;
                            height: 160px;
                            background: #FFFFFF;
                            border-radius: 15px 15px 15px 15px;
                            overflow: hidden;
                        }

                        .kefu_popup_content_item_content_btn {
                            width: 200px;
                            height: 48px;
                            background: #F0F5FF;
                            // box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
                            border-radius: 15px;
                            background: #11B55E;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            gap: 6px;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 600;
                            font-size: 18px;
                            color: #FFFFFF;
                            text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);

                            img {
                                // width: 32px;
                                // height: 32px;
                            }

                            span {
                                font-family: PingFang SC, PingFang SC;
                            }
                        }

                    }



                }
            }

        }


    }
}

:deep(.gonggao_popup) {
    width: 518px;
    height: 702px;
    background: #F0F5FF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
    border-radius: 20px 20px 20px 20px;
    box-sizing: border-box;


    .el-dialog__header {
        // display: none;
        background: none !important;
        border-bottom: none !important;
        padding: 0px !important;

    }

    .el-dialog__body {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 30px 23px;


        .gonggao_popup_content {
            width: 100%;
            height: 100%;

            display: flex;
            flex-direction: column;

            gap: 10px;
            position: relative;

            .gonggao_popup_content_title {
                width: 100%;
                height: 42px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 32px;
                color: #0A1C46;
            }

            .gonggao_popup_content_content_time {
                width: 100%;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
            }


            .gonggao_popup_content_content {
                width: 100%;
                height: 100%;
                background: wheat;
                border-radius: 15px;

                // .imgbox {
                //     width: 472px !important;
                //     height: 560px;
                // }





            }

            .guanbiicon {
                width: 48px;
                height: 48px;
                position: absolute;
                bottom: -120px;

                cursor: pointer;
                // 左右居中
                left: 50%;
                transform: translateX(-50%);


            }
        }
    }

}

.mian {
    width: 100%;
    height: 100%;

    background: #F3F3F3;
    display: flex;

    .Dropdownbox {
        width: 160px;
        height: auto;
        // background: wheat;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        position: relative;

        .ellipsis {
            width: 80px;
            text-align: center;
            /* 必须设置固定宽度或max-width */
            white-space: nowrap;
            /* 禁止换行 */
            overflow: hidden;
            /* 隐藏溢出内容 */
            text-overflow: ellipsis;
            /* 显示省略符号 */

        }


    }


    .leftbox {
        width: 220px;
        height: 100%;
        background: #FFFFFF;
        box-shadow: 2px 0px 8px 0px rgba(0, 0, 0, 0.1);
        border-radius: 0px 0px 0px 0px;
        position: relative;
        flex-shrink: 0;

        .imgbox {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
            flex-shrink: 0;
        }

        .listbox {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 2;
            box-sizing: border-box;
            padding: 43px 0px;
            display: flex;
            flex-direction: column;
            align-items: center;


            .iconbox {
                width: 137px;
                height: 30px;
                margin-bottom: 40px;


            }

            .search {
                width: 180px;
                height: 28px;
                // background: #FFFFFF;
                border-radius: 8px;
                display: flex;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 14px 10px;
                margin-bottom: 20px;

                .inputbox {
                    width: 130px;
                    height: 100%;
                    border: none !important;
                }

                .searchiconbox {
                    width: 22px;
                    height: 22px;
                }



            }

            .menubox {
                width: 100%;
                flex: 1;
                box-sizing: border-box;
                padding: 0 20px;

                // background: wheat;
                ::v-deep(.el-menu) {
                    background: none;
                    border: none;

                    .el-sub-menu {

                        // background: red;
                        border-radius: 15px;
                        margin-bottom: 20px !important;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 600;
                        font-size: 16px;
                        // --el-menu-item-hover-fill:#FF8C00 !important;
                        --el-menu-hover-bg-color: none;
                        --el-menu-item-height: 42px;
                        overflow: hidden;

                        .el-icon {
                            margin-right: 12px !important;
                        }


                        .el-icon svg {
                            width: 20px;
                            height: 20px;
                            // color: black;
                            font-weight: bold;
                            transform: rotate(-90deg);

                            // transform: rotateZ(-90deg);
                        }

                        .el-sub-menu__icon-arrow {
                            color: black
                        }

                        .el-menu--inline {
                            // background: rgba(240, 245, 255, 1);
                            // background: red;

                            font-family: PingFang SC, PingFang SC;
                            font-weight: 600;
                            font-size: 18px;
                            // width: 10%;
                            // color: red;


                        }

                        .is-opened {
                            background-color: #1f2d3d;

                            /* 展开时的背景色（与选中状态区分） */
                        }

                        .el-sub-menu__title {
                            height: 48px !important;
                            border: 2px solid white;
                            font-size: 18px !important;
                            box-sizing: border-box;
                            transition: none !important;
                            //   background: red !important;
                            --el-menu-base-level-padding: 10px // padding: none !important;s
                                // .el-icon el-sub-menu__icon-arrow{

                                // }
                                // --el-menu-level-padding: 10px #888888;


                        }

                        .el-menu-item {
                            // width: 10px !important;
                            // padding-left: 20px;

                            font-weight: 400;
                            font-size: 16px !important;
                            // background: red;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            // color: #888888;

                        }

                        .is-active::before {
                            content: "";
                            position: absolute;
                            top: 50%;
                            left: 10%;
                            width: 8px;
                            height: 8px;
                            border-radius: 50%;
                            border: 2px solid #0F68D6;
                            transform: translateY(-50%);
                            box-sizing: border-box;


                        }

                        span {
                            color: black !important;
                        }

                    }

                    .is-opened {
                        background: rgba(240, 245, 255, 1);
                        // background: linear-gradient(90deg, #0E68D6 0%, #61B5E7 100%);
                        border-radius: 15px 15px 15px 15px;

                        // border: 2px solid #A5DCFF;
                        span {
                            color: white !important;
                        }

                        .el-icon svg {
                            width: 20px;
                            height: 20px;
                            color: black;
                            font-weight: bold;
                            transform: rotate(-0deg) !important;
                            color: white;
                            // transform: rotateZ(-90deg) !important;
                        }

                        .el-sub-menu__title {
                            height: 48px !important;
                            font-size: 18px !important;
                            background: linear-gradient(90deg, #0E68D6 0%, #61B5E7 100%);
                            border-radius: 15px 15px 15px 15px;
                            border: 2px solid #A5DCFF;
                            box-sizing: border-box;
                            transition: none !important;
                            --el-menu-base-level-padding: 10px // padding: none !important;s
                                // .el-icon el-sub-menu__icon-arrow{

                                // }
                                // --el-menu-level-padding: 10px #888888;


                        }

                        .el-sub-menu__icon-arrow {
                            color: white
                        }
                    }

                }

            }

            // background:red;
        }
    }

    .rightbox {
        width: calc(100% - 220px);
        height: 100%;
        box-sizing: border-box;
        padding-left: 40px;

        display: flex;
        flex-direction: column;
        background: rgba(240, 245, 255, 1);

        header {
            width: 100%;
            height: 80px;
            // background: red;
            border-radius: 0px 0px 0px 20px;
            display: flex;
            justify-content: space-between;

            .Page_Routing {
                width: 400px;
                height: 100%;
                // background: wheat;
            }

            .plaintext {
                min-width: 100px;
                height: 100%;
                box-sizing: border-box;
                padding: 0 20px;
                display: flex;
                align-items: center;
                gap: 30px;
                // background: wheat;

                .iconbox {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    // margin-right: 30px;
                    position: relative;
                    z-index: 1;
                    object-fit: cover;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .icondd::after {
                    content: "";
                    position: absolute;
                    top: 6px;
                    right: 6px;
                    width: 10px;
                    height: 10px;
                    // background: #FF4C4C;
                    border-radius: 50%;

                    background: red;
                    z-index: 1000;
                }

                .conentbox {
                    width: 120px;
                    height: 48px;
                    background: #FFFFFF;
                    border-radius: 24px 24px 24px 24px;
                    display: flex;
                    overflow: hidden;

                    .unloginbtn {
                        // background: red;
                        width: calc(100% - 48px);
                        height: 48px;
                        line-height: 48px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #0A1C46;
                        // padding: 10px;
                        box-sizing: border-box;
                        // 超出省略号
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center;
                        box-sizing: border-box;
                        padding: 0px 8px;

                    }

                }

            }
        }

        .main {
            flex: 1;
            height: 100%;
            box-sizing: border-box;

            // border-radius: 15px;
            // overflow: hidden;
            // padding-bottom: 20px;
            overflow-y: auto;
            padding-right: 40px;
            // background:white;
        }
    }

}
</style>
<style>
.el-popover.monitor-yt-popoverone_100086 {
    width: 160px !important;
    height: auto !important;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    overflow: hidden;
    padding: 0px !important;


    /* inset: <top> <right> <bottom> <left>; */

}

.monitor-yt-popoverone_100086 .el-popper__arrow:before {
    display: none;
}

.monitor-yt-popoverone_100086 .el-popover__title {
    color: white;
}


.monitor-yt-popoverone_100086 .popper__arrow::after {
    border-top-color: #090d29 !important;
}
</style>
